import { openModal } from 'components/Modal/actions'
import { isEmpty } from 'lodash'
import { sendNotification } from 'pages/Administration/helpers'

export const handleInstanceInsertion = (
  handleOnChange,
  { instance, role, permissions },
  allInstances,
  roles,
  isRoleInvalid,
  isInstanceInvalid
) => {
  return [
    {
      id: 'instance_id',
      labelText: 'Administration:RolesManagement.InstancesModal.Instances',
      placeholder: 'Administration:RolesManagement.InstancesModal.Instances',
      isDisabled: false,
      isInvalid: isInstanceInvalid,
      invalidText:
        isInstanceInvalid && 'Administration:RolesManagement.RequiredValue',
      name: 'instance',
      value: instance,
      type: 'select',
      selectedItem: {
        label: instance.label,
        value: instance.value
      },
      handleChange: (e) =>
        handleOnChange({
          instance: e.selectedItem
        }),
      itemsList: allInstances?.map((instance) => {
        return {
          label: instance.title,
          value: instance.id
        }
      })
    },
    {
      id: 'roles_id',
      labelText: 'Administration:RolesManagement.InstancesModal.Roles',
      placeholder: 'Administration:RolesManagement.InstancesModal.Roles',
      isDisabled: false,
      isInvalid: isRoleInvalid,
      invalidText:
        isRoleInvalid && 'Administration:RolesManagement.RequiredValue',
      name: 'role',
      value: role,
      type: 'select',
      selectedItem: {
        label: role.label,
        value: role.value
      },
      handleChange: (e) =>
        handleOnChange({
          role: e.selectedItem
        }),
      itemsList: roles?.map((role) => {
        return {
          label: role?.roleName,
          value: role?.roleName
        }
      })
    },
    {
      id: 'permissions_id',
      labelText: 'Administration:RolesManagement.InstancesModal.Permissions',
      label: 'Administration:RolesManagement.InstancesModal.Permissions',
      placeholder: 'Administration:RolesManagement.InstancesModal.Permissions',
      isDisabled: false,
      isInvalid: false,
      invalidText: '',
      name: 'permissions',
      value: permissions,
      type: 'multiselect',
      initialSelectedItems: [],
      handleChange: (e) =>
        handleOnChange({
          permissions: e.selectedItems
        }),
      itemsList: [
        {
          label: 'Administration:RolesManagement.RolesColumn.Read',
          value: 1,
          text: 'read'
        },
        {
          label: 'Administration:RolesManagement.RolesColumn.Create',
          value: 4,
          text: 'create'
        },
        {
          label: 'Administration:RolesManagement.RolesColumn.Update',
          value: 5,
          text: 'update'
        },
        {
          label: 'Administration:RolesManagement.RolesColumn.Delete',
          value: 6,
          text: 'delete'
        },
        {
          label: 'Administration:RolesManagement.RolesColumn.Import',
          value: 2,
          text: 'import_'
        },
        {
          label: 'Administration:RolesManagement.RolesColumn.Export',
          value: 3,
          text: 'export'
        }
      ]
    }
  ]
}
export const handleInstanceCloning = (
  handleOnChange,
  { instance, role },
  allInstances,
  roles,
  isRoleInvalid,
  isInstanceInvalid
) => [
  {
    id: 'instance_id',
    labelText: 'Administration:RolesManagement.InstancesModal.ToInstance',
    isDisabled: false,
    isInvalid: isInstanceInvalid,
    invalidText:
      isInstanceInvalid && 'Administration:RolesManagement.RequiredValue',
    name: 'instance',
    value: instance,
    type: 'select',
    selectedItem: {
      label: instance.label,
      value: instance.value
    },
    handleChange: (e) =>
      handleOnChange({
        instance: e.selectedItem
      }),
    itemsList: allInstances?.map((instance) => {
      return {
        label: instance.title,
        value: instance.id
      }
    })
  },
  {
    id: 'roles_id',
    labelText: 'Administration:RolesManagement.InstancesModal.ToRole',
    isDisabled: false,
    isInvalid: isRoleInvalid,
    invalidText:
      isRoleInvalid && 'Administration:RolesManagement.RequiredValue',
    name: 'role',
    value: role,
    type: 'select',
    selectedItem: {
      label: role.label,
      value: role.value
    },
    handleChange: (e) =>
      handleOnChange({
        role: e.selectedItem
      }),
    itemsList: roles?.map((role) => {
      return {
        label: role?.roleName,
        value: role?.roleName
      }
    })
  }
]

export const handleOpenModal = (e) => {
  const { colDef } = e
  return colDef.field === 'permission'
}

export const getPermissionPayload = ({ oldPermission, column }) => ({
  ...oldPermission,
  [column]: !oldPermission[column]
})

export const getFieldPermissionPayload = (element, bulk, parent) => {
  const permissionPayload = {}

  parent && bulk
    ? copyParentPermission(element, parent)
    : (element.oldPermission[element.column] =
        !element.oldPermission[element.column])

  permissionPayload.read = element.oldPermission.read
  permissionPayload.import_ = element.oldPermission.import_
  permissionPayload.export = element.oldPermission.export
  permissionPayload.create = element.oldPermission.create
  permissionPayload.update = element.oldPermission.update
  permissionPayload.delete = element.oldPermission.delete
  return permissionPayload
}

const copyParentPermission = (child, parent) => {
  child.oldPermission.read = parent.oldPermission.read
  child.oldPermission.import_ = parent.oldPermission.import_
  child.oldPermission.export = parent.oldPermission.export
  child.oldPermission.create = parent.oldPermission.create
  child.oldPermission.update = parent.oldPermission.update
  child.oldPermission.delete = parent.oldPermission.delete
}

export const updatePermissionModal = (
  onUpdateModalSubmit,
  onUpdateSecondaryModalSubmit,
  t
) => {
  openModal('confirmAction', {
    modalHeading: t('Common:UpdatePermissions'),
    message: t('Common:PermissionConfirmation'),
    onConfirm: onUpdateModalSubmit,
    onCancel: onUpdateSecondaryModalSubmit,
    primaryButtonText: t('Common:Overwrite'),
    secondaryButtonText: t('Common:UpdateOnlyOneRecord'),
    loadingOverlay: true
  })
}

export const resetPermissionModal = (
  onResetModalSubmit,
  onResetSecondaryModalSubmit,
  t
) => {
  openModal('confirmAction', {
    modalHeading: t('Common:ResetInstance'),
    message: t('Common:InstanceResetConfirmation'),
    onConfirm: onResetModalSubmit,
    onCancel: onResetSecondaryModalSubmit,
    primaryButtonText: t('Common:Reset'),
    secondaryButtonText: t('Common:ResetOnlyOneRecord'),
    loadingOverlay: true
  })
}

export const processInstanceValidation = (
  { instance },
  setIsInstanceInvalid
) => {
  instance && setIsInstanceInvalid(isEmpty(instance))
  return instance && isEmpty(instance)
}

export const processRoleValidation = ({ role }, setIsRoleInvalid) => {
  role && setIsRoleInvalid(isEmpty(role))
  return role && isEmpty(role)
}

export const notifySuccess = (info, t) =>
  sendNotification({ t, info, kind: 'success' })
